export default __webpack_public_path__ + "static/media/settings.168bd09a.png";